import React from "react";
import { CheckCircle } from "lucide-react";

const CheckListItem = ({ text, size = "md" }) => {
  return (
    <div className="flex items-start space-x-3">
      <CheckCircle
        className={`text-emerald-600 flex-shrink-0 mt-1 ${
          size === "sm" ? "w-5 h-5" : "w-6 h-6"
        }`}
      />
      <p className={`text-gray-700 ${size === "lg" ? "text-lg" : ""}`}>
        {text}
      </p>
    </div>
  );
};

export default CheckListItem;
